import { useState } from "react";

export function useLocalStorage<T>(
  key: string,
  initialValue: T,
  inParent: boolean = false,
) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = (inParent ? window.parent : window).localStorage.getItem(
        key,
      );
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        (inParent ? window.parent : window).localStorage.setItem(
          key,
          JSON.stringify(valueToStore),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue] as const;
}
